import React, { useState } from "react";

const Faq = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {
      question: "What makes your AI platform different for professionals?",
      answer:
        "Our platform combines practical, hands-on training with real-world applications, focusing on immediate productivity gains and long-term career advancement."
    },
    {
      question: "How quickly can I see results from using AI in my work?",
      answer:
        "Most professionals see measurable productivity improvements within the first week of applying AI tools, with deeper workflow optimization within 30 days."
    },
    {
      question: "What kind of support do you provide for individual users?",
      answer:
        "We offer dedicated support including live Q&A sessions, community forums, one-on-one mentoring, and a comprehensive resource library."
    },
    {
      question: "What happens if I miss a live session?",
      answer:
        "All live sessions are recorded and made available for replay. We also provide session summaries and follow-up materials so you never miss key insights."
    },
    {
      question: "What qualifications do your instructors have?",
      answer:
        "Our instructors are industry practitioners with extensive experience in AI implementation, business strategy, and professional development across multiple sectors."
    },
    {
      question: "Will I receive a certificate upon completion of the course?",
      answer:
        "Yes. All participants receive a professional certificate of completion that can be shared on LinkedIn and included in your portfolio or CV."
    },
    {
      question: "Are there opportunities for hands-on practice or real-world projects?",
      answer:
        "Every program includes practical exercises, case studies, and real-world project opportunities to ensure you can apply what you learn immediately."
    },
    {
      question: "How do you ensure the content stays up to date with the latest AI trends?",
      answer:
        "Our curriculum is continuously updated by our expert team, with quarterly reviews and monthly content updates to reflect the latest AI developments."
    },
    {
      question: "Is there a community or network for course participants?",
      answer:
        "Yes. Participants gain access to our professional community for networking, peer collaboration, and ongoing support beyond the program."
    },
    {
      question: "What are the technical requirements for participating in the course?",
      answer:
        "You’ll need a computer with a reliable internet connection, a modern web browser, and basic familiarity with common business software. Access to AI tools is provided."
    },
    {
      question: "How do you accommodate different learning styles?",
      answer:
        "We offer multiple learning formats including live sessions, recordings, written materials, interactive exercises, and opportunities for peer collaboration."
    }
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <section className="bg-gradient-to-b from-black to-gray-900 py-10 sm:py-20 lg:py-20 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin tracking-wide mb-4 sm:mb-6 text-white">
            Frequently Asked <span className="text-gray-400">Questions</span>
          </h2>
          <div className="w-24 sm:w-32 h-px bg-white mx-auto mb-4 sm:mb-6" />
          <p className="text-sm sm:text-base text-gray-400 max-w-2xl mx-auto leading-relaxed">
            Answers to some of the most common questions about our AI programs, learning experience, and support.
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-800">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full text-left py-4 sm:py-5 flex justify-between items-center hover:text-gray-300 transition-colors"
                aria-expanded={openFaq === index}
              >
                <span className="text-sm sm:text-base md:text-lg font-light tracking-wide pr-6 sm:pr-8">
                  {faq.question}
                </span>
                <span className="text-xl sm:text-2xl font-thin flex-shrink-0">
                  {openFaq === index ? "−" : "+"}
                </span>
              </button>
              {openFaq === index && (
                <div className="pb-5 sm:pb-6 text-gray-400 leading-relaxed text-sm sm:text-base">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
